export const DATE_FORMATS = {
    DATE:              "dd/MM/yyyy",
    DATE_HM:           "dd/MM/yyyy HH:mm",
    DATETIME:          "dd/MM/yyyy ",
    TIMEDATE:          "HH:mm:ss dd/MM/yyyy",
    DATE_KEY:          "yyyyMMdd",
    TIME:              "HH:mm:ss",
    HOUR_MINUTE:       "HH:mm",
    DB:                "yyyy-MM-dd HH:mm:ss",
    DB_DATE:           "yyyy-MM-dd",
    HOURS:             "HH",
    MINUTES:           "mm",
    SECONDS:           "t",
    MILLISECONDS:      "T",

    DATE_HEADER:    "EEEE, dd/MM/yyyy",
    DATE_HM_DASH:   "dd/MM/yyyy - HH:mm"
}
